import {
  createClient,
  ssrExchange,
  cacheExchange,
  fetchExchange,
  errorExchange,
} from "urql";
import { retryExchange, RetryExchangeOptions } from "@urql/exchange-retry";
import Cookies from "js-cookie";
import { logOut } from "./auth";
import { requestPolicyExchange } from "@urql/exchange-request-policy";

const options: RetryExchangeOptions = {
  initialDelayMs: 1000,
  maxDelayMs: 15000,
  randomDelay: true,
  maxNumberAttempts: 3,
  retryIf: (err: any) => err && err.networkError,
};

const API_URL = import.meta.env.VITE_PUBLIC_GRAPHQL_URL!;

export const ssr = ssrExchange();

export const makeClient = () =>
  createClient({
    url: API_URL,
    exchanges: [
      requestPolicyExchange({
        ttl: 5 * 1000,
        shouldUpgrade: (operation) =>
          operation.context.requestPolicy !== "cache-only",
      }),
      cacheExchange,
      ssr,
      retryExchange(options),
      errorExchange({
        onError: (error) => {
          console.error("GraphQL error:", error);
        },
      }),
      fetchExchange,
    ],
    requestPolicy: "cache-first",
    fetch: (...args) =>
      fetch(...args).then((response) => {
        if (response.status === 401) {
          logOut();
          throw Error("Unauthorized");
        }
        return response;
      }),
    fetchOptions: () => {
      let token = undefined;
      if (typeof window !== "undefined") {
        token = Cookies.get("elevatetoken");
      } else {
        token = Cookies.get("elevatetoken");
      }
      return !token ? {} : { headers: { Authorization: `Bearer ${token}` } };
    },
  });
